<table
  infiniteScroll
  [infiniteScrollDistance]="0"
  [infiniteScrollThrottle]="500"
  [infiniteScrollDisabled]="infiniteScrollDisabled"
  (scrolled)="loadNextEvents.emit()"
  class="table table-hover tableLatest media-horizontal-scroll"
  >
  <thead>
    <tr>
      <th></th>
      <th>{{ "START_TIME" | translate }}</th>
      <th>{{ "DEVICE" | translate }}</th>
      <th>{{ "EVENT" | translate }}</th>
      <th>{{ "USER_OR_RECIPIENT" | translate }}</th>
      <th>{{ "END_TIME" | translate }}</th>
    </tr>
  </thead>

  <tbody>
    @for (row of cameraEvents; track row; let e = $even; let i = $index) {
      <!-- Header row -->
      <tr class="trCollapse" [ngClass]="{ trEven: e }" (click)="expandRow(row, i)">
        <td><span class="fa-light" [ngClass]="!row.expanded ? 'fa-plus' : 'fa-minus'"></span></td>
        <td>{{ row.visitStarted | moment : "l LTS" }} </td>
        <td class="media-display">
            @if (row.camera?.anonymizedPropExists) {
            <div class="eye-pos-fix media-eye-pos"><i class="fa-solid fa-eye-slash"></i></div>
            }
            {{ row.camera?.displayName || row.camera?.cameraId }}
        </td>
        <td>{{ (row.camera?.visitType || '') | langCode | translate }}</td>
        <td>
          @if (row.camera?.anonymizedPropExists && !row.camera?.anonymizedStatus) {
            <div class="eye-pos-fix"><i class="fa-solid fa-eye"></i></div>
          }
          <span [ngClass]="{'text-danger': !row.userName }">
            @if (!row.userName) {
              <span class="fa-light fa-fw fa-exclamation-triangle text-danger"></span>
            }
            {{ row.userName || "MISSED_CAMERA_VISIT" |translate}}
          </span>
        </td>
        <td>{{ row.visitEnd | moment : "l LTS" }}</td>
      </tr>
      <!-- Detail row -->
      @if (row.expanded) {
        <tr [ngClass]="{ trEven: e }">
          <td colspan="6" class="tdDetailsWrap">
            <div class="row">
              <div class="col-md-3">
                <div>
                  <strong> {{ "START_TIME" | translate }}:</strong> {{ row.visitStarted | moment : "l LTS"}}
                  <br />
                  <strong> {{ "END_TIME" | translate }}: </strong> {{ row.visitEnd | moment : "l LTS"}}
                  <br />
                  <strong> {{ "CAMERA_VISIT_DURATION" | translate }}: {{ row.visitStarted | visitDuration : row.visitEnd : row.visitSnoozedAt : row.visitResumedAt }} </strong>
                  <br />
                  @if (row.alert?.id && row.alert?.activationGroup != null && row.alert?.activationNode != null && row.alert?.time) {
                    <br />
                    <strong>{{ "RELATED_ALARM" | translate }}: </strong>
                    <span
                      class="text-primary cursorPointer"
                      style="text-decoration: underline;"
                      (click)="openLinkedAlertHandler(row); $event.stopPropagation()">
                      {{ getRelatedAlertName(row) }} - {{ row.alert.time | moment : "l LTS" }}
                    </span>
                  }
                </div>
              </div>
              <div class="col-md-3">
                <div>
                  <strong> {{ "VISIT_TYPE" | translate }}: </strong> @if (row.camera?.anonymizedPropExists) {
                  <span>{{ "ANONYMIZED" | translate }} {{ (row.camera?.visitType || '').toLowerCase() | langCode | translate}}</span>
                  }@if (!row.camera?.anonymizedPropExists) {
                  <span>{{ (row.camera?.visitType || '') | langCode | translate }}</span>
                }
                @if (row.camera?.anonymizedPropExists && !row.camera?.anonymizedStatus) {
                  <span class="clear-image-badge"><i class="fa-solid fa-eye"></i> {{"CLEAR_IMAGE_VIEWED" | translate}}</span>
                }
                <br />
                <!-- Visit snoozing time -->
                @if (row.visitSnoozedAt) {
                  <strong> {{ "VISIT_SNOOZED_AT" | translate }}: </strong>
                  {{ row.visitSnoozedAt | date: 'HH:mm:ss' }}
                  <br />
                }
                <!-- Visit resumed time -->
                @if (row.visitResumedAt) {
                  <strong> {{ "VISIT_RESUMED_AT" | translate }}: </strong>
                  {{ row.visitResumedAt | date: 'HH:mm:ss' }}
                  <br />
                }
                <!-- Origon calls during visit -->
                @if (row.origonCall?.length) {
                  <div class="origon-call-title">
                    <i class="fa-solid fa-phone"></i>
                    <strong> {{ "CALL_DURING_VISIT" | translate }}: </strong>
                  </div>
                  @for (call of row.origonCall; track call) {
                    @if (call?.origonId) {
                      <div class="origon-call-row">
                        <span class="origon-call-name">{{ call.origonName || call.origonId }}</span>
                        <span class="origon-call-time">{{ call.callTime | date: 'HH:mm:ss' }}</span>
                      </div>
                    }
                  }
                }
                <!-- User connected -->
                @if (row.camera?.userConnectedAt) {
                  <i class="fa-solid fa-user-check"></i>
                  <strong> {{ "USER_CONNECTED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.userConnectedAt) | date: 'HH:mm:ss' }}<br />
                }
                <!-- Anonymization Disabled -->
                @if (row.camera?.anonymizationDisabledAt) {
                  <i class="fa-solid fa-eye"></i>
                  <strong> {{ "ANONYMIZATION_DISABLED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.anonymizationDisabledAt) | date: 'HH:mm:ss' }}<br />
                }
                @if (row.camera?.anonymizationEnabledAt) {
                  <i class="fa-solid fa-eye-slash"></i>
                  <strong> {{ "ANONYMIZATION_ENABLED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.anonymizationEnabledAt) | date: 'HH:mm:ss' }}<br />
                }
                <!-- Speaker On/Off -->
                @if (row.camera?.speakerEnabledAt) {
                  <i class="fa-solid fa-volume-high"></i>
                  <strong> {{ "SPEAKER_ENABLED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.speakerEnabledAt) | date: 'HH:mm:ss' }}<br />
                }
                @if (row.camera?.speakerDisabledAt) {
                  <i class="fa-solid fa-volume-xmark"></i>
                  <strong> {{ "SPEAKER_DISABLED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.speakerDisabledAt) | date: 'HH:mm:ss' }}<br />
                }
                <!-- Microphone On/Off -->
                @if (row.camera?.microphoneEnabledAt) {
                  <i class="fa-solid fa-microphone"></i>
                  <strong> {{ "MICROPHONE_ENABLED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.microphoneEnabledAt) | date: 'HH:mm:ss' }}<br />
                }
                @if (row.camera?.microphoneDisabledAt) {
                  <i class="fa-solid fa-microphone-slash"></i>
                  <strong> {{ "MICROPHONE_DISABLED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.microphoneDisabledAt) | date: 'HH:mm:ss' }}<br />
                }
                <!-- Furniture Viewed -->
                @if (row.camera?.furnitureViewedAt) {
                  <i class="fa-solid fa-couch"></i>
                  <strong> {{ "FURNITURE_VIEWED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.furnitureViewedAt) | date: 'HH:mm:ss' }}<br />
                }
                <!-- Visit end. Not in use -->
                @if (row.camera?.userDisconnectedAt) {
                  <i class="fa-solid fa-user-slash"></i>
                  <strong> {{ "USER_DISCONNECTED_AT" | translate }}:</strong> {{ $safeNavigationMigration(row.camera?.userDisconnectedAt) | date: 'HH:mm:ss' }}<br />
                }
              </div>
            </div>
          </div>
        </td>
      </tr>
    }
    <!-- Detail row -->
  }
</tbody>
</table>
